/* MAD LEATHER theme behaviours — vanilla, no dependencies */
(function () {
  'use strict';

  var on = function (el, ev, fn) { el && el.addEventListener(ev, fn); };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Sticky header ---------- */
  var header = $('[data-ml-header]');
  if (header) {
    var solid = function () { header.classList.toggle('is-solid', window.scrollY > 40); };
    solid();
    on(window, 'scroll', solid);
  }

  /* ---------- Mobile drawer ---------- */
  var drawer = $('[data-ml-drawer]');
  $$('[data-ml-drawer-open]').forEach(function (b) {
    on(b, 'click', function () { drawer && drawer.classList.add('is-open'); });
  });
  $$('[data-ml-drawer-close]').forEach(function (b) {
    on(b, 'click', function () { drawer && drawer.classList.remove('is-open'); });
  });

  /* ---------- Announcement rotator ---------- */
  $$('[data-ml-announcement]').forEach(function (bar) {
    var msgs = $$('.ml-announcement__msg', bar);
    if (msgs.length < 2) return;
    var i = 0;
    var interval = parseInt(hero.dataset.mlHeroInterval || '6000', 10);
    var timer;
    var show = function (n) {
      i = (n + msgs.length) % msgs.length;
      msgs.forEach(function (m, x) { m.classList.toggle('is-active', x === i); });
    };
    $$('[data-ml-announcement-prev]', bar).forEach(function (b) { on(b, 'click', function () { show(i - 1); }); });
    $$('[data-ml-announcement-next]', bar).forEach(function (b) { on(b, 'click', function () { show(i + 1); }); });
    setInterval(function () { show(i + 1); }, 6000);
  });

  /* ---------- Hero slider ---------- */
  $$('[data-ml-hero]').forEach(function (hero) {
    var slides = $$('.ml-hero__slide', hero);
    var dots = $$('.ml-hero__dot', hero);
    if (slides.length < 2) return;
    var i = 0;
    var go = function (n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, x) { s.classList.toggle('is-active', x === i); });
      dots.forEach(function (d, x) { d.classList.toggle('is-active', x === i); });
    };
    dots.forEach(function (d, x) { on(d, 'click', function () { go(x); }); });
    $$('[data-ml-hero-prev]', hero).forEach(function (b) { on(b, 'click', function () { go(i - 1); }); });
    $$('[data-ml-hero-next]', hero).forEach(function (b) { on(b, 'click', function () { go(i + 1); }); });
    var play = function () { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, interval); };
    play();
    on(hero, 'mouseenter', function () { clearInterval(timer); });
    on(hero, 'mouseleave', play);
    on(hero, 'focusin', function () { clearInterval(timer); });
    on(hero, 'focusout', play);
  });

  /* ---------- Carousel arrows ---------- */
  $$('[data-ml-carousel]').forEach(function (wrap) {
    var track = $('[data-ml-track]', wrap);
    if (!track) return;
    var step = function (dir) {
      track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.8, 240), behavior: 'smooth' });
    };
    $$('[data-ml-prev]', wrap).forEach(function (b) { on(b, 'click', function () { step(-1); }); });
    $$('[data-ml-next]', wrap).forEach(function (b) { on(b, 'click', function () { step(1); }); });
  });

  /* ---------- Tabs / chips filtering ---------- */
  $$('[data-ml-tabs]').forEach(function (group) {
    var chips = $$('[data-ml-tab]', group);
    var scope = group.closest('[data-ml-tab-scope]') || document;
    chips.forEach(function (chip) {
      on(chip, 'click', function () {
        var value = chip.dataset.mlTab;
        chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        $$('[data-ml-tab-item]', scope).forEach(function (item) {
          var tags = (item.dataset.mlTabItem || '').split('|');
          item.classList.toggle('ml-hidden', value !== 'all' && tags.indexOf(value) === -1);
        });
      });
    });
  });

  /* ---------- Product card variants (size + colour) ---------- */
  $$('[data-ml-card]').forEach(function (card) {
    var variants;
    try { variants = JSON.parse($('[data-ml-variants]', card).textContent); } catch (e) { return; }
    var priceEl = $('[data-ml-price]', card);
    var compareEl = $('[data-ml-compare]', card);
    var skuEl = $('[data-ml-sku]', card);
    var imgEl = $('[data-ml-image]', card);
    var lowEl = $('[data-ml-low]', card);
    var cta = $('[data-ml-atc]', card);
    var state = { size: null, color: null };

    var money = function (cents) {
      var f = card.dataset.mlMoneyFormat || '₹{{amount}}';
      return f.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0 }));
    };

    var match = function () {
      return variants.filter(function (v) {
        return (!state.size || v.size === state.size) && (!state.color || v.color === state.color);
      })[0] || variants[0];
    };

    var render = function () {
      var v = match();
      if (!v) return;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        compareEl.textContent = v.compare_at_price ? money(v.compare_at_price) : '';
        compareEl.classList.toggle('ml-hidden', !v.compare_at_price);
      }
      if (skuEl) skuEl.textContent = v.sku || '';
      if (imgEl && v.image) imgEl.src = v.image;
      if (lowEl) {
        var low = v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5;
        lowEl.textContent = low ? 'Only ' + v.inventory_quantity + ' left' : '';
        lowEl.classList.toggle('ml-hidden', !low);
      }
      if (cta) {
        cta.dataset.variantId = v.id;
        cta.disabled = !v.available;
        cta.textContent = v.available ? (cta.dataset.labelAdd || 'Add to cart') : (cta.dataset.labelSold || 'Sold out');
      }
    };

    $$('[data-ml-size]', card).forEach(function (b) {
      on(b, 'click', function (e) {
        e.preventDefault();
        state.size = b.dataset.mlSize;
        $$('[data-ml-size]', card).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        render();
      });
    });
    $$('[data-ml-color]', card).forEach(function (b) {
      on(b, 'click', function (e) {
        e.preventDefault();
        state.color = b.dataset.mlColor;
        $$('[data-ml-color]', card).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        render();
      });
    });

    var firstSize = $('[data-ml-size]', card);
    var firstColor = $('[data-ml-color]', card);
    if (firstSize) { state.size = firstSize.dataset.mlSize; firstSize.classList.add('is-active'); }
    if (firstColor) { state.color = firstColor.dataset.mlColor; firstColor.classList.add('is-active'); }
    render();

    if (cta) {
      on(cta, 'click', function (e) {
        e.preventDefault();
        var id = cta.dataset.variantId;
        if (!id) return;
        cta.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            cta.textContent = 'Added';
            var count = $('[data-ml-cart-count]');
            if (count) count.textContent = String((parseInt(count.textContent, 10) || 0) + 1);
            setTimeout(function () { cta.disabled = false; render(); }, 1400);
          })
          .catch(function () { cta.disabled = false; });
      });
    }
  });

  /* ---------- Collection filter drawer ---------- */
  var filters = $('[data-ml-filters]');
  $$('[data-ml-filters-toggle]').forEach(function (b) {
    on(b, 'click', function () { filters && filters.classList.toggle('is-open'); });
  });

  /* ---------- Sort ---------- */
  var sort = $('[data-ml-sort]');
  on(sort, 'change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    window.location.href = url.toString();
  });

  /* ---------- Recently viewed ---------- */
  var KEY = 'ml_recently_viewed';
  var handle = document.body.dataset.mlProductHandle;
  if (handle) {
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  var rv = $('[data-ml-recently-viewed]');
  if (rv) {
    var stored = [];
    try { stored = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
    if (!stored.length) { rv.classList.add('ml-hidden'); }
    else {
      var track = $('[data-ml-track]', rv);
      var shown = 0;
      stored.slice(0, 8).forEach(function (h) {
        fetch('/products/' + h + '?view=card')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html || !track) return;
            var d = document.createElement('div');
            d.innerHTML = html.trim();
            if (d.firstElementChild) { track.appendChild(d.firstElementChild); shown++; }
          });
      });
      if (!shown && !stored.length) rv.classList.add('ml-hidden');
    }
  }

  /* ---------- Product recommendations ---------- */
  var rec = $('[data-ml-recommendations]');
  if (rec) {
    fetch(rec.dataset.url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var d = document.createElement('div');
        d.innerHTML = html;
        var next = d.querySelector('[data-ml-recommendations]');
        if (next) rec.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  }
})();
